import logger from "../utils/logger";

export async function getLCAStatementData(filters: any) {
    console.log("Fetching LCA statement data with filters:", filters);

    try {
        let _q = `SELECT 
            py.uuid,
            c.name,
            py.py_month AS _m,
            DATE_FORMAT(STR_TO_DATE(CONCAT(py.py_year, '-', LPAD(py.py_month, 2, '0'), '-01'), '%Y-%m-%d'), '%M') AS month1,
            py.py_year AS year,
            DATE_FORMAT(STR_TO_DATE(CONCAT(py.py_year, '-', LPAD(py.py_month, 2, '0'), '-01'), '%Y-%m-%d'), '%Y-%m') AS month,
            COALESCE(fin_hours.total_hrs, 0) AS totalHrs,
            py.gross_pay AS actual_wages,
            py.net_pay AS total_earnings,
            lm.location_1,
            lm.location_2,
            lm.location_3,
            CAST(COALESCE(lm.lca_rate_1, 0) AS DECIMAL(10,2)) AS lca_rate_1,
            CAST(COALESCE(lm.lca_rate_2, 0) AS DECIMAL(10,2)) AS lca_rate_2,
            CAST(COALESCE(lm.lca_rate_3, 0) AS DECIMAL(10,2)) AS lca_rate_3,
            lm.effective_dt,
            COALESCE(fin_hours.total_hrs, 0) * CAST(COALESCE(lm.lca_rate_1, 0) AS DECIMAL(10,2)) AS calculated_wages_1,
            COALESCE(fin_hours.total_hrs, 0) * CAST(COALESCE(lm.lca_rate_2, 0) AS DECIMAL(10,2)) AS calculated_wages_2,
            COALESCE(fin_hours.total_hrs, 0) * CAST(COALESCE(lm.lca_rate_3, 0) AS DECIMAL(10,2)) AS calculated_wages_3,
            py._d_start,
            py._d_end
        FROM (
            SELECT uuid,
                   MONTH(_d_start) AS py_month,
                   YEAR(_d_start) AS py_year,
                   MIN(_d_start) AS _d_start,
                   MAX(_d_end) AS _d_end,
                   SUM(e_regular) AS gross_pay,
                   SUM(net_pay) AS net_pay
            FROM payroll
            GROUP BY uuid, MONTH(_d_start), YEAR(_d_start)
        ) py
        LEFT JOIN consultant c ON py.uuid = c.uuid
        LEFT JOIN lca_master lm ON py.uuid = lm.uuid 
            AND lm.effective_dt = (
                SELECT MAX(lm2.effective_dt) 
                FROM lca_master lm2 
                WHERE lm2.uuid = py.uuid AND lm2.effective_dt <= STR_TO_DATE(CONCAT(py.py_year, '-', LPAD(py.py_month, 2, '0'), '-01'), '%Y-%m-%d')
            )
        LEFT JOIN (
            SELECT uuid, MONTH(_d) AS fin_month, YEAR(_d) AS fin_year, SUM(hrs) AS total_hrs
            FROM finance
            WHERE hrs > 0
            GROUP BY uuid, MONTH(_d), YEAR(_d)
        ) fin_hours ON py.uuid = fin_hours.uuid 
            AND py.py_month = fin_hours.fin_month 
            AND py.py_year = fin_hours.fin_year`;

        if (filters?.checkDate) {
            const date = new Date(filters.checkDate);
            _q += ` WHERE py.py_month = ${date.getMonth() + 1} AND py.py_year = ${date.getFullYear()}`;
        }

        if (filters?.employee && filters.employee !== "") {
            if (filters?.checkDate) {
                _q += ` AND py.uuid = '${filters.employee}'`;
            } else {
                _q += ` WHERE py.uuid = '${filters.employee}'`;
            }
        }

        _q += ` AND py.gross_pay > 0`;

        _q += ` ORDER BY c.name, py.py_year DESC, py.py_month DESC`;

        console.log(_q);

        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["payroll"],
            }),
        });
        const result = await response.json();
        console.log("LCA Statement Result:", JSON.stringify(result, null, 2));
        return result;
    } catch (error) {
        logger.error("getLCAStatementData failed", { filters }, error);
        return [];
    }
}
